import React, { useState, useEffect } from 'react';
import './ReloadPrompt.css';

function ReloadPrompt() {
  const [needRefresh, setNeedRefresh] = useState(false);
  const [updateServiceWorker, setUpdateServiceWorker] = useState(null);

  useEffect(() => {
    // Check if service worker is supported
    if ('serviceWorker' in navigator) {
      // Try to import the PWA register function dynamically
      import('virtual:pwa-register').then(({ registerSW }) => {
        const updateSW = registerSW({
          onNeedRefresh() {
            console.log('New content available, prompting for refresh');
            setNeedRefresh(true);
            setUpdateServiceWorker(() => updateSW);
          },
          onOfflineReady() {
            // Don't show offline ready message since app requires internet
            console.log('Service worker ready');
          },
          onRegistered(registration) {
            console.log('SW Registered: ', registration);
          },
          onRegisterError(error) {
            console.log('SW registration error', error);
          },
        });
      }).catch((error) => {
        console.log('PWA not available:', error);
      });
    }
  }, []);

  const close = () => {
    setNeedRefresh(false);
  };

  const handleReload = () => {
    if (updateServiceWorker) {
      updateServiceWorker(true);
    }
  };

  if (needRefresh) {
    return (
      <div className="ReloadPrompt-container">
        <div className="ReloadPrompt-toast">
          <div className="ReloadPrompt-message">
            <span>🔥 New update available! Click reload to get the latest features.</span>
          </div>
          <button className="ReloadPrompt-button" onClick={handleReload}>
            Reload
          </button>
          <button className="ReloadPrompt-button" onClick={close}>
            Close
          </button>
        </div>
      </div>
    );
  }

  return null;
}

export default ReloadPrompt;
